const en = {
    LOADING: 'Loading...',
    SUB_TEXT: 'Subtitle Text',
    OPEN_VIDEO: 'Open Video',
    OPEN_YT: 'Import YouTube',
    OPEN_SUB: 'Open Subtitle',
    EXPORT_ASS: 'Export ASS',
    EXPORT_SRT: 'Export SRT',
    EXPORT_VTT: 'Export VTT',
    EXPORT_VIDEO: 'Export Video',
    TRANSLATE: 'Translation',
    TRANSLATING: 'Translation...',
    TRANSLAT_SUCCESS: 'Translation success',
    DECODE_START: 'Start decoding audio',
    DECODE_SUCCESS: 'Decoding audio success',
    DECODE_ERROR: 'Decoding audio failed',
    VIDEO_EXT_ERR: 'Unable to open this video format',
    SUB_EXT_ERR: 'Unable to open this subtitle format',
    MOBILE_TIP: 'Please use computer access',
    HOTKEY_01: 'Space: Play / Pause',
    HOTKEY_02: 'Ctrl + Z: Undo',
    CLEAR: 'Clear',
    UNDO: 'Undo',
    DELETE: 'Delete Subtitle',
    MERGE: 'Merge Next',
    SPLIT: 'Split Subtitle',
    LOADING_FFMPEG: 'Loading dependency...',
    LOADING_FONT: 'Loading font...',
    LOADING_VIDEO: 'Loading video...',
    LOADING_SUB: 'Loading subtitle...',
    CLEAR_TIP: 'Confirm that all data is cleared',
    BURN_ERROR: 'Burn subtitles failed',
    BURN_START: 'Start burn subtitles',
    BURN_SUCCESS: 'Burn subtitles success',
    OPEN_VIDEO_ERROR: 'Please open the video first',
};

const i18n = {
    en
};

export default i18n;
